import React from 'react'
import Navbar from '../../navbar/Navbar'

function Register() {
  return (
    <div>
    <Navbar/>
    </div>
  )
}

export default Register